export class JSONParseError extends Error {
	name = "JSONParseError";

	constructor(text: string) {
		super(`Did not receive JSON, instead received: ${text}`);

		Object.setPrototypeOf(this, JSONParseError.prototype);
	}
}
